export const CPF_FORMAT = /^(\d{3})(\d{3})(\d{3})(\d{2})$/;
export const CNPJ_FORMAT = /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/;
